// extracted by mini-css-extract-plugin
export default {"content":"style_content__LYlIU","leftSide":"style_leftSide__nmKSb","rightSide":"style_rightSide__FiPZ7","type":"style_type__usaXO"};